import '../styles/testimonials.css';
import TiltCard from './TiltCard';

const TestimonialsSection = () => {
  const testimonials = [
    {
      text: '"I sold my Toyota Corolla within 4 days of listing. The Verified badge made buyers trust me straight away. Brilliant app!"',
      initials: "CK", name: "Chanda Kaluba", role: "Lusaka",
      badge: "Seller", badgeBg: "var(--orange-light)", badgeColor: "var(--orange-dark)",
      avatarBg: "linear-gradient(135deg,#2fa86b,#1f7a4d)",
    },
    {
      text: '"Found my dream Prado in Kitwe in 2 days. The in-app chat was safe and easy. I never had to share my personal number."',
      initials: "MN", name: "Mutale Nkonde", role: "Ndola",
      badge: "Buyer", badgeBg: "var(--secondary)", badgeColor: "var(--secondary-foreground)",
      avatarBg: "linear-gradient(to bottom right,#f5862a,#b85e1a)",
    },
    {
      text: '"The dealer account completely changed how we operate. We close far more deals and reach customers we never could before."',
      initials: "BM", name: "Brighton Mwale", role: "Lusaka",
      badge: "Dealer", badgeBg: "var(--dealer-light)", badgeColor: "var(--dealer)",
      avatarBg: "linear-gradient(to bottom right,#6366f1,#4f46e5)",
    },
  ];

  return (
    <section className="testimonials">
      <div className="container">
        <span className="section-tag animate-on-scroll">⭐ Real Reviews</span>
        <h2 className="section-title animate-on-scroll">Loved Across Zambia</h2>
        <p className="section-desc animate-on-scroll">From first-time buyers to seasoned dealers, here's what real ZamWheelz users say.</p>
        <div className="testimonials-grid stagger-children">
          {testimonials.map((t) => (
            <TiltCard className="testimonial-card animate-on-scroll" key={t.name} max={6}>
              <div className="stars">★★★★★</div>
              <p className="quote">{t.text}</p>
              <div className="testimonial-footer">
                <div className="avatar" style={{ background: t.avatarBg }}>{t.initials}</div>
                <div>
                  <strong>{t.name}</strong>
                  <span>{t.role}</span>
                </div>
                <span className="testimonial-badge" style={{ background: t.badgeBg, color: t.badgeColor }}>
                  {t.badge}
                </span>
              </div>
            </TiltCard>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
